<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="950"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center error white--text"
        >
          <v-icon
            large
            dark
          >
            bug_report
          </v-icon>
          Unexpected Error Messages
        </v-card-title>
        <v-card-text
          class="error--text"
        >
          Oops - we did not expect that!
          Please solve the problem yourself by replaying single events or call 911 :)
        </v-card-text>
        <v-card-text
          v-if="approvalStep === 'bankTransferApproval'"
          light
        >
          <table>
            <tr>
              <th
                class="text-xs-center"
              >
                User ID
              </th>
              <th
                class="text-xs-center"
              >
                Message
              </th>
            </tr>
            <tr
              v-for="error in errors"
              :key="error.index"
            >
              <td
                valign="top"
              >
                {{ error.user_id }}
              </td>
              <td>
                {{ error.message }}
              </td>
            </tr>
          </table>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'HolderErrorMessagesDialog',
  components: {
  },
  props: {
    visible: Boolean,
    errors: {
      type: Array,
      required: true,
    },
    approvalStep: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>
<style lang="scss"/>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/payout/HolderErrorMessagesDialog.vue